module.exports = __webpack_public_path__ + "img/IMG_1839.bcddd3c8.jpg";